<script setup>
import { computed } from 'vue';
import { useCompetitorAppConfig } from 'src/composables/useCompetitorAppConfig';

const props = defineProps({
  technicalProperty: {
    type: Object,
    required: true,
  }
});

const { getApplicationType, getTechnicalPropertyType } = useCompetitorAppConfig();

const propertyTypeConfig = computed(() => getTechnicalPropertyType(props.technicalProperty.propertyType));
const applicationTypeConfig = computed(() => getApplicationType(props.technicalProperty.applicationType));

const preparedValue = computed(() => {
  let { value } = props.technicalProperty;

  if (propertyTypeConfig.value.dataType === 'rgb') {
    return `<div class="flex items-center"><img class="rgb" src="${value.image}"> <span>${value.r},${value.g},${value.b}</span></div>`;
  }

  if (propertyTypeConfig.value.dataType === 'nested_list') {
    return value
      .map((row) => {
        const listOption = propertyTypeConfig.value?.listOptions?.find((o) => o.code === row.code);

        return {
          title: listOption?.title ?? row.code,
          value: row.value,
          unit: listOption?.unit ?? null,
        };
      })
      .map((row) => {
        let rowValue = row.value;
        if (row.unit) {
          rowValue = `${rowValue} ${row.unit}`;
        }

        return `<p><span class="font-bold">${row.title}</span><br>${rowValue}</span></p>`;
      })
      .join('');
  }

  if (propertyTypeConfig.value.unit) {
    value = `${value} ${propertyTypeConfig.value.unit}`;
  }

  return `<strong>${value}</strong>`;
});
</script>

<template>
  <div
    class="ce-technicalPropertySimpleValue"
    :class="[`ce-technicalPropertySimpleValue--${propertyTypeConfig.dataType}`]">
    <div class="title">
      {{ applicationTypeConfig.title }}:
    </div>

    <div
      class="value"
      v-html="preparedValue" />
  </div>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-technicalPropertySimpleValue {
  display: table-row;

  > div {
    display: table-cell;
    vertical-align: middle;

    &.title {
      padding: @space-1 @space-5 @space-1 0;
    }

    &.value {
      padding: @space-1 0;

      img.rgb {
        width: 30px;
        height: 30px;
        border-radius: 4px;
        overflow: hidden;
        margin-right: @space-2;
      }
    }
  }
}
</style>
